import React from 'react';
import { TabWrapper, Tab } from './Tabbutton.styles';

const TabButton = ({ tabs = [], active, onChange, style }) => (
  <TabWrapper style={style}>
    {tabs.map((tab) => (
      <Tab
        key={tab.key}
        $active={active === tab.key}
        onClick={() => onChange?.(tab.key)}
        type="button"
      >
        {tab.label}
      </Tab>
    ))}
  </TabWrapper>
);

export default TabButton;
